import { Api } from "./api"

export class CuppingSessionsPermissionApi extends Api {
  constructor() {
    super('cupping_sessions_permissions', ['canCreateCuppingSessions'])
  }
}
